import React from 'react'
import styled from 'styled-components'
import NavButton, {
  NavButtonWithSize,
} from 'Event/Dashboard/components/NavButton'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import Published from 'Event/Dashboard/editor/views/Published'
import {Draggable} from 'react-beautiful-dnd'
import {DraggableOverlay} from 'lib/ui/drag-and-drop'
import {useEditMode} from 'Event/EditModeProvider'
import {useToggle} from 'lib/toggle'
import {SidebarNavButtonConfig} from 'Event/template/Cards/Dashboard/Sidebar/SidebarItem/SidebarNav/SidebarNavButtonConfig'
import {useLoadFont} from 'lib/FontSelect'
import {SidebarNavProps} from 'Event/template'
import {useAttendeeVariables} from 'Event'

export default React.memo(
  (
    props: NavButtonWithSize & {
      id: string
      index: number
      nav: SidebarNavProps
      listId: string
    },
  ) => {
    const isEditMode = useEditMode()

    const {flag: configVisible, toggle: toggleConfig} = useToggle()
    const {flag: configCopyVisible, toggle: toggleCopyConfig} = useToggle()

    const v = useAttendeeVariables()

    useLoadFont(props.font)

    const button = (
      <Published component={props}>
        <StyledNavButtonComponent
          aria-label="sidebar nav button"
          textColor="#FFFFFF"
          borderWidth={1}
          borderColor="#FFFFFF"
          onClick={isEditMode ? toggleConfig : () => {}}
          {...props}
          text={v(props.text)}
        />
      </Published>
    )

    if (!isEditMode) {
      return button
    }

    return (
      <>
        <SidebarNavButtonConfig
          button={props}
          id={props.id}
          listId={props.listId}
          showing={configVisible}
          onClose={toggleConfig}
        />
        <SidebarNavButtonConfig
          button={props}
          listId={props.listId}
          showing={configCopyVisible}
          onClose={toggleCopyConfig}
        />
        <Draggable draggableId={props.id} index={props.index}>
          {(provided) => (
            <div ref={provided.innerRef} {...provided.draggableProps}>
              <DraggableOverlay>
                <Editable
                  onEdit={toggleConfig}
                  onCopy={toggleCopyConfig}
                  handleProps={provided.dragHandleProps}
                >
                  <>{button}</>
                </Editable>
              </DraggableOverlay>
            </div>
          )}
        </Draggable>
      </>
    )
  },
)

const StyledNavButtonComponent = styled(NavButton)`
  font-size: 14px;
  padding: ${(props) => `${props.theme.spacing[3]} ${props.theme.spacing[4]}`};
  margin: ${(props) => props.theme.spacing[3]} 0;
`
